import { render, staticRenderFns } from "./EventTemplateForm.vue?vue&type=template&id=12dfa3f1&scoped=true&"
import script from "./EventTemplateForm.vue?vue&type=script&lang=js&"
export * from "./EventTemplateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dfa3f1",
  null
  
)

export default component.exports